import { configureStore } from '@reduxjs/toolkit'
import sceneControllerReducer from './slice/sceneSlice'

export const store = configureStore({
  reducer: {sceneController: sceneControllerReducer,},
})